import { useState } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import SupportMentorCalendar from 'src/supportPortal/components/common/mentor/mentorCalendar/SupportMentorCalendar'
import ScreenerConsultationsView from './ScreenerConsultationsView'

const SCREENER_BY_SLUG_API = '/api/secure/cc/support/screeners/by-slug'

export default function ScreenerBookings() {
  const [tab, setTab] = useState('consultations')

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={tab}
        onChange={(_e, value) => setTab(value)}
        sx={{ borderBottom: 1, borderColor: 'divider', px: { xs: 1, sm: 2 } }}
      >
        <Tab value="consultations" label="Consultations" />
        <Tab value="screening-calendar" label="Screening calendar" />
      </Tabs>

      {tab === 'consultations' ? (
        <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
          <ScreenerConsultationsView />
        </Box>
      ) : (
        <SupportMentorCalendar dontOpenReports getSingleMentorApiSignature={SCREENER_BY_SLUG_API} />
      )}
    </Box>
  )
}
